import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { hasPurpleDoorAccess } from "@/lib/purpledoor/access";

/**
 * Gate hook for the PurpleDoor section. Returns "checking" until the
 * localStorage access key is confirmed on the client; returns "granted"
 * once it is. When the key is missing it redirects to "/" and stays in
 * "checking" so protected content is never rendered.
 */
export default function usePurpleDoorAccess() {
    const router = useRouter();
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        if (hasPurpleDoorAccess()) {
            setStatus("granted");
        } else {
            router.replace("/");
        }
    }, [router]);

    return status;
}
